import React from 'react';
import '../../styles/Template5.css';
import logo from '../../uploads/logo.png';
import avatar from '../../uploads/avatar.png';
import earth from '../../uploads/earth.png';

const Template5 = ({ formData, educationData, languageData, computerSkillsData, employmentData, registrationAddress }) => {
    const imageUrl = formData.Photo ? `data:image/jpeg;base64, ${formData.Photo}` : avatar;
	let birthPlace = `${formData.BirthPlace.Country.Name ? formData.BirthPlace.Country.Name : ''}${formData.BirthPlace.City ? `, ${formData.BirthPlace.City}` : ''}`;
    const reversedEmploymentData = employmentData.slice().reverse();
    const formatDate = (date) => {
        const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    }

    const isObjectEmpty = (data) => {
        for (const item of data) {
            for (const key in item) {
                if (typeof item[key] === 'object') {
                    const subItem = item[key];
                    for (const subKey in subItem) {
                        if (subItem[subKey] !== '') {
                            return false;
                        }
                    }
                } else if (item[key] !== '') {
                    return false;
                }
            }
        }
        return true;
    };

	return (
		<>
		<div className="template5-container">
            <div className='dark-element'></div>
            <div className='avatar-box'>
                <img src={imageUrl} className='avatar' alt='avatar' />
            </div>
            <h1>{formData.Name}</h1>
            <div className='content-box-left'>
                <div className='content-box-left-item'>
                    <h3>образование</h3>
                    {!isObjectEmpty(educationData) && educationData.map((edu, index) => (
                        <div key={`edu${index}`} className='content-box-left-education-item'>
                            <p>{edu.Institution.Name}</p>
                            <p>{edu.Faculty}</p>
                            <p>С {formatDate(edu.Start)} по {formatDate(edu.End)}</p>
                        </div>
                    ))}
                </div>
                <div className='content-box-left-item'>
                    <h3>контактные данные</h3>
                    <p>Почта: {formData.EmailPersonal}</p>
                    <p>Телефон: {formData.MobilePhoneWork.value}</p>
                    <p>Адрес: {registrationAddress.ViewAddresses}</p>
                </div>
                <div className='content-box-left-item'>
                    <h3>курсы и тренинги</h3>    
                </div>
            </div>
            <div className='content-box-right'>
                <div className='content-box-right-item'>
                    <h3>опыт работы</h3>                    
                    {!isObjectEmpty(reversedEmploymentData) && reversedEmploymentData.map((employment, index) => (
                        <div key={`emp${index}`} className='content-box-right-employment-item'>
                            <p>{employment.Organization} | {employment.Position}</p>
                            <p style={{ fontStyle: 'italic' }}>С {formatDate(employment.EmploymentDate)} по {employment.DismissalDate ? formatDate(employment.DismissalDate) : 'Н.В.'}</p>
                            <p style={{ fontSize: '8pt' }}>{employment.Duties}</p>                        
                        </div>                 
                    ))}             
                </div>
                <div className='content-box-right-item'>
                    <h3 style={{ background: 'rgba(255, 87, 87, 1)', marginLeft: '-8px', paddingLeft: '23px' }}>навыки</h3><br/>
                    <div className='content-box-right-experience-item'>
                        <h1>Знание языков</h1>
                        {!isObjectEmpty(languageData) && languageData.map((lang, index) => (
                            <p key={`lang${index}`}>{lang.Language.Name} - {lang.LanguageDegree.Name}</p>                    
                        ))}  
                    </div>
                    <div className='content-box-right-experience-item'>
                        <h1>Профессиональные навыки</h1>
                        {!isObjectEmpty(computerSkillsData) && computerSkillsData.map((skill, index) => (
                            <p key={`comp${index}`}>{skill.Software.Name} - {skill.SoftwareLevel.Name}</p>
                        ))}
                    </div>                                  
                </div>
            </div>
        </div>
		</>
	);
};

export default Template5;
